/* eslint-disable no-nested-ternary */
import BasicBlogOptions from './BasicBlogOptions';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useState } from 'react';
import Button from '@mui/material/Button';
import AddCircle from '@mui/icons-material/AddCircle';
import Tooltip from '@mui/material/Tooltip';

export default function HostingDashboard({
  blogs,
  openBlogWizard,
  page,
  paymentSuccess,
  initialSelectedBlog,
  refetchHostingPlan,
}) {
  const [selectedBlog, setSelectedBlog] = useState(initialSelectedBlog);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const handleBlogSelect = newBlog => {
    setSelectedBlog(newBlog.target.value);
  };

  const changeOrAdd = (
    <>
      {blogs.length > 1 && (
        <FormControl
          variant="outlined"
          margin="dense"
          disabled={hasUnsavedChanges}
        >
          <Select
            variant="outlined"
            className="tw-rounded-r-none"
            id="blog-select"
            value={selectedBlog}
            onChange={handleBlogSelect}
            sx={{ height: '40px' }}
          >
            {blogs.map((blog, i) => (
              <MenuItem key={blog.blogTitle} value={i}>
                {blog.blogTitle}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <Button
        className={
          'mt-2 tw-h-10' + (blogs.length > 1 ? ' tw-rounded-l-none' : '')
        }
        variant="contained"
        color="primary"
        onClick={openBlogWizard}
        disabled={hasUnsavedChanges}
      >
        <AddCircle />
      </Button>
    </>
  );

  return (
    <>
      <div className="tw-relative tw-h-12">
        <div className="tw-top-0 tw-right-0 tw-absolute">
          {hasUnsavedChanges ? (
            <Tooltip
              title="You have unsaved changes"
              placement="bottom"
              className="tw-cursor-help"
            >
              <div>{changeOrAdd}</div>
            </Tooltip>
          ) : (
            changeOrAdd
          )}
        </div>
      </div>
      <BasicBlogOptions
        key={blogs[selectedBlog].blogTitle}
        blog={blogs[selectedBlog]}
        hasUnsavedChanges={hasUnsavedChanges}
        setHasUnsavedChanges={setHasUnsavedChanges}
        page={page}
        paymentSuccess={paymentSuccess}
        refetchHostingPlan={refetchHostingPlan}
      />
    </>
  );
}
